import type { AttributeType } from "./AttributeComponent";
import type { JobAttribute } from "../../../../__generated__/types.gqlgenerated";

export const ATTRIBUTE_ORDER: Record<AttributeType, string[]> = {
  jobTypes: [
    "CF3CP",
    "75GKK",
    "NJXCK",
    "4HKF7",
    "VDTG7",
    "5QWDV",
    "7EQCZ",
    "T9BXE",
    "CPAHG",
    "CJWTS",
    "ZG59D",
    "UXQZ8",
    "7SBAT",
    "HS8UZ",
    "9SYVT",
  ],
  shiftAndSchedule: [
    "SAP7A",
    "PMS5Q",
    "5GUGE",
    "7SRRR",
    "5WFZM",
    "EQHS8",
    "4XK2Y",
    "VDB9U",
    "H3N5U",
    "VZD9Q",
    "FM8WH",
    "9TG7M",
    "K8AKP",
    "93HC4",
    "H7VK5",
  ],
  benefits: [],
};

export function sortAttributes(attributes: JobAttribute[], order: string[]): JobAttribute[] {
  if (order.length === 0) return attributes;
  return [...attributes].sort((a, b) => {
    const indexA = order.indexOf(a.key);
    const indexB = order.indexOf(b.key);

    if (indexA === -1 && indexB === -1) return (a.label ?? "").localeCompare(b.label ?? "");
    if (indexA === -1) return 1;
    if (indexB === -1) return -1;

    return indexA - indexB;
  });
}

export function sortAttributesByType(
  attributes: JobAttribute[],
  type: AttributeType,
): JobAttribute[] {
  return sortAttributes(attributes, ATTRIBUTE_ORDER[type]);
}
